export default {
  highcharts: {
    decimalPoint: ',',
    downloadJPEG: 'Pobierz obraz JPEG',
    downloadPDF: 'Pobierz dokument PDF',
    downloadPNG: 'Pobierz obraz PNG',
    downloadSVG: 'Pobierz obraz SVG',
    exportButtonTitle: 'Eksport',
    forexRate: 'Kurs średni FOREX',
    loading: 'Ładowanie...',
    months: [
      'Styczeń',
      'Luty',
      'Marzec',
      'Kwiecień',
      'Maj',
      'Czerwiec',
      'Lipiec',
      'Sierpień',
      'Wrzesień',
      'Październik',
      'Listopad',
      'Grudzień',
    ],
    printButtonTitle: 'Drukowanie',
    rangeSelectorFrom: 'Od',
    rangeSelectorTo: 'Do',
    rangeSelectorZoom: 'Przybliżenie',
    rateTypes: {
      ask: 'Najlepsza oferta sprzedaży',
      bid: 'Najlepsza oferta kupna',
      forex: 'Średni kurs na świecie',
    },
    resetZoom: 'Reset',
    resetZoomTitle: 'Reset',
    shortMonths: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
    thousandsSep: ' ',
    weekdays: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
    wtBestAsk: 'Najlepsza oferta sprzedaży',
    wtBestBid: 'Najlepsza oferta kupna',
  },
  calculator: {
    title: 'Calcular el ahorro en Walutomat',
    forBuy: 'para',
    unsupportedPair: 'Actualmente no ofrecemos tarifas para el par de divisas seleccionado.',
    spinnerError: {
      generic: 'Hubo un problema con la descarga de datos',
      toManyRequests:
        'Muchos usuarios están utilizando la calculadora en este momento. Inténtelo de nuevo más tarde o póngase en contacto con el servicio de atención al cliente <a href="https://www.walutomat.com/es/pongase-en-contacto-con/">https://www.walutomat.com/es/pongase-en-contacto-con/</a>.',
    },
    commissionWT: 'Comisión de Walutomat',
    continueButton: 'Continuar el cambio',
    amountText: 'Importe',
  },
  continueButton: {
    createAccount: 'Crea una cuenta gratuita',
    logIn: 'Iniciar sesión',
    check: 'Comprobar',
    checkWhyWorth: 'por qué vale la pena',
  },
  dashboard: {
    canEditPost: 'Możesz edytować wpis',
    postExists: 'Wpis o takim tytule już istnieje',
    postNotExists: 'Wpis o takim tytule nie istnieje',
    emptyPostTitle: 'Dodaj tytuł wpisu',
    error: 'Coś poszło nie tak :(',
  },
  widgetCalculator: {
    title: 'Comprueba los tipos de cambio y{{nbsp}}cambia divisas en{{nbsp}}Walutomat – rápido y{{nbsp}}ventajoso.',
    actualRate: 'Tipo de cambio actual',
    buySelect: 'Comprar',
    sellSelect: 'Vendo',
    buttonText: 'Cambiar',
    exchangeAmountSellLabel: 'Recibirás',
    exchangeAmountBuyLabel: 'Depósito',
    commission: 'Comisión promocional ({{commission}}%)',
  },
  formValidation: {
    emptyField: 'El campo no puede estar vacío',
    requiredField: 'El campo es obligatorio',
    requireAllFields: 'Todos los campos deben estar completos',
    passwordToShort: 'La contraseña debe tener 8 caracteres',
    emailNotValid: 'El campo debe contener una dirección de correo electrónico válida',
    emailReserved: 'La dirección de correo electrónico ya está ocupada',
    emailUnregistered: 'No encontramos tu dirección de correo electrónico en nuestra base de datos de clientes.',
    markField: 'Marque al menos una de las casillas',
    serverUnknownError: 'Error de comunicación con el servidor',
    invalidCharacters: 'El campo contiene caracteres no válidos',
    phoneNotValid: 'El número de teléfono es incorrecto',
    checkBoxBelow: 'Por favor, marque la casilla de abajo para enviar un mensaje',
    promocodeInvalid: 'Código de promoción no válido',
    newsletterAlreadySubscribed: 'Este correo electrónico ya está suscrito al boletín.',
  },
  password: {
    show: 'mostrar',
    hide: 'ocultar',
  },
  howItWorks: {
    showButton: 'Mostrar más',
    hideButton: 'Mostrar menos',
  },
}
